import { render, staticRenderFns } from "./kyc-details.vue?vue&type=template&id=85b4f332"
import script from "./kyc-details.vue?vue&type=script&lang=js"
export * from "./kyc-details.vue?vue&type=script&lang=js"
import style0 from "./kyc-details.vue?vue&type=style&index=0&id=85b4f332&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports